var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShortcode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 8C1.25 7.0335 2.0335 6.25 3 6.25H7C7.41421 6.25 7.75 6.58579 7.75 7C7.75 7.41421 7.41421 7.75 7 7.75H3C2.86193 7.75 2.75 7.86193 2.75 8V16C2.75 16.1381 2.86193 16.25 3 16.25H7C7.41421 16.25 7.75 16.5858 7.75 17C7.75 17.4142 7.41421 17.75 7 17.75H3C2.0335 17.75 1.25 16.9665 1.25 16V8Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 8C22.75 7.0335 21.9665 6.25 21 6.25H17C16.5858 6.25 16.25 6.58579 16.25 7C16.25 7.41421 16.5858 7.75 17 7.75H21C21.1381 7.75 21.25 7.86193 21.25 8V16C21.25 16.1381 21.1381 16.25 21 16.25H17C16.5858 16.25 16.25 16.5858 16.25 17C16.25 17.4142 16.5858 17.75 17 17.75H21C21.9665 17.75 22.75 16.9665 22.75 16V8Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9474 6.29024C13.5554 6.15652 13.1292 6.36592 12.9955 6.75795L9.58447 16.758C9.45075 17.15 9.66015 17.5762 10.0522 17.71C10.4442 17.8437 10.8704 17.6343 11.0042 17.2422L14.4152 7.24221C14.5489 6.85017 14.3395 6.42396 13.9474 6.29024Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortcode);
export default __webpack_public_path__ + "static/media/shortcode.5164cf52ccdd059b2973a56eac9c1ebb.svg";
export { ForwardRef as ReactComponent };